import React from 'react';
import './VideoPlayer.css';

function toYouTubeEmbed(url) {
  if (!url) return null;
  try {
    const u = new URL(url);
    // Already an embed URL
    if (u.hostname.includes('youtube.com') && u.pathname.startsWith('/embed/')) {
      return url;
    }
    // Standard watch URL: https://www.youtube.com/watch?v=VIDEO_ID
    if (u.hostname.includes('youtube.com') && u.searchParams.get('v')) {
      const id = u.searchParams.get('v');
      return `https://www.youtube.com/embed/${id}`;
    }
    // Short URL: https://youtu.be/VIDEO_ID
    if (u.hostname === 'youtu.be') {
      const id = u.pathname.replace('/', '');
      if (id) return `https://www.youtube.com/embed/${id}`;
    }
  } catch (e) {
    // fall through and treat as non-YouTube
  }
  return null;
}

export default function VideoPlayer({ src, poster, title }) {
  const isYouTube = !!src && (src.includes('youtube.com') || src.includes('youtu.be'));
  const ytEmbed = isYouTube ? toYouTubeEmbed(src) : null;
  const hasVideo = !!ytEmbed || !!src;

  return (
    <div className="video-player-wrap">
      <div className="video-player-aspect">
        {isYouTube && ytEmbed ? (
          <iframe
            className="video-player"
            src={ytEmbed}
            title={title || 'Lesson video'}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        ) : (
          <video
            className="video-player"
            src={src || undefined}
            poster={poster}
            controls
            playsInline
          />
        )}
        {!hasVideo && (
          <div className="video-player-placeholder">
            <div className="video-player-placeholder-icon">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <polygon points="5 3 19 12 5 21 5 3" />
              </svg>
            </div>
            <p className="video-player-placeholder-text">Video lesson</p>
            <p className="video-player-placeholder-sub">{title || 'No video URL configured for this lesson.'}</p>
          </div>
        )}
      </div>
    </div>
  );
}
